import { ReactNode } from "react";

import BulkActionsConfirmActionStep from "components/BulkActions/ConfirmActionStep";
import { BulkActionsVariant } from "components/BulkActions/types";

import {
  StackRolesBulkActionsAnalyticsPayload,
  StackRolesBulkActionsConfirmActionStepProps,
  StackRolesBulkActionItem,
  StackRolesMutationVariables,
} from "../types";
import StackRolesBulkActionsConfirmActionStepDefault from "./Default";

type StackRolesBulkActionsConfirmActionFormProps = {
  action: StackRolesBulkActionItem;
  variant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: StackRolesMutationVariables,
    analyticsPayload: StackRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const StackRolesBulkActionsConfirmActionForm = ({
  action,
  variant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: StackRolesBulkActionsConfirmActionFormProps) => {
  const props: StackRolesBulkActionsConfirmActionStepProps = {
    bulkActionsVariant: variant,
    onConfirm,
    onCancel,
    action,
    customConfirmationMessage,
  };

  const actionComponent = <StackRolesBulkActionsConfirmActionStepDefault {...props} />;

  return <BulkActionsConfirmActionStep>{actionComponent}</BulkActionsConfirmActionStep>;
};

export default StackRolesBulkActionsConfirmActionForm;